import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageClosedProductAccountLayer from "../../../components/Admin/ManageClosedProductAccount";

const ManageClosedProductAccount = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageClosedProductAccountLayer />
      </MasterLayout>
    </>
  );
};
export default ManageClosedProductAccount